import { Link, useParams } from 'react-router-dom';
import { courseRegistry } from '../../courses/courseRegistry';

export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL

console.log("Fetching notes from:", `${API_URL}/notes`); //change ro packges

export default function PackageGateway() {
  const { courseSlug } = useParams();
  const courseConfig = courseRegistry[courseSlug];

  if (!courseConfig) return <div>Course not found</div>;
  
  const PackagesComponent = courseConfig.packageComponent;

  if (!PackagesComponent) return <div>No packages for this course loaded yet</div>;

  return <PackagesComponent />;
}
